import AbstractClient from './AbstractClient'

class AuthClient extends AbstractClient {
  authenticate (credentials) {
    return this.post('/auth/login', credentials)
  }

  revoke () {
    return this.post('/auth/logout')
  }
}

export default new AuthClient()
